module.exports = __webpack_public_path__ + "static/media/Pineco_gaussian2.216b56ff.png";